export default __webpack_public_path__ + "static/banner1-16d6cb5e220be7886fb059655de4ed9a.jpg";